export default "__VITE_ASSET__4f10a93d__"